/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["vi",[["s","c"],["SA","CH"]],[["SA","CH"]],[["CN","T2","T3","T4","T5","T6","T7"],["CN","Th 2","Th 3","Th 4","Th 5","Th 6","Th 7"],["Chá»§ Nháº­t","Thá»© Hai","Thá»© Ba","Thá»© TÆ°","Thá»© NÄm","Thá»© SÃ¡u","Thá»© Báº£y"],["CN","T2","T3","T4","T5","T6","T7"]],u,[["1","2","3","4","5","6","7","8","9","10","11","12"],["thg 1","thg 2","thg 3","thg 4","thg 5","thg 6","thg 7","thg 8","thg 9","thg 10","thg 11","thg 12"],["thÃ¡ng 1","thÃ¡ng 2","thÃ¡ng 3","thÃ¡ng 4","thÃ¡ng 5","thÃ¡ng 6","thÃ¡ng 7","thÃ¡ng 8","thÃ¡ng 9","thÃ¡ng 10","thÃ¡ng 11","thÃ¡ng 12"]],[["1","2","3","4","5","6","7","8","9","10","11","12"],["ThÃ¡ng 1","ThÃ¡ng 2","ThÃ¡ng 3","ThÃ¡ng 4","ThÃ¡ng 5","ThÃ¡ng 6","ThÃ¡ng 7","ThÃ¡ng 8","ThÃ¡ng 9","ThÃ¡ng 10","ThÃ¡ng 11","ThÃ¡ng 12"]],[["TCN","CN"],["TCN","SCN"],["TrÆ°á»c ChÃºa GiÃ¡ng Sinh","Sau CÃ´ng NguyÃªn"]],1,[6,0],["d/M/yy","d MMM, y","d MMMM, y","EEEE, d MMMM, y"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{0} {1}",u,u,u],[",",".",";","%","+","-","E","Ã","â°","â","NaN",":"],["#,##0.###","#,##0%","#,##0.00Â Â¤","#E0"],"VND","â«","Äá»ng Viá»t Nam",{"AUD":["AU$","$"],"BYN":[u,"Ñ."],"PHP":[u,"â±"],"THB":["à¸¿"],"TWD":["NT$"],"USD":["US$","$"],"XXX":[]},"ltr", plural];
